import { render } from "./words.vue?vue&type=template&id=4342c258&scoped=true&ts=true"
import script from "./words.vue?vue&type=script&lang=ts"
export * from "./words.vue?vue&type=script&lang=ts"

import "./style/index.scss?vue&type=style&index=0&id=4342c258&lang=scss&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/3Mswgxxg/0/im/im-web/iguopin-chat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4342c258"]])

export default __exports__